import { Component, OnInit, Input } from '@angular/core';
import { ProjectTool, Project } from 'toolbandi-ui-lib';
import { Search, CrudService, MessageService } from 'elbuild-ui-lib-core';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { forkJoin } from 'rxjs';
import { ProjectToolAddComponent } from '../project-tool-add/project-tool-add.component';
import { DialogService } from 'elbuild-ui-componentslib';

@Component({
	selector: 'app-project-tool-list',
	templateUrl: './project-tool-list.component.html',
	styleUrls: ['./project-tool-list.component.scss']
})
export class ProjectToolListComponent implements OnInit {

	@Input()
	projectid: number;

	@Input()
	companyid: number;
	project: Project;

	loading: boolean = false;
	rows: ProjectTool[];

	advancedSearch = new Search('projecttool join tool on projecttool.toolid = tool.id');

	get page() {
		if (this.advancedSearch) {
			return this.advancedSearch.page;
		} else {
			return undefined;
		}
	}

	constructor(
		private toolService: CrudService<ProjectTool>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private modalService: NgbModal,
		private dialogService: DialogService
	) {
		this.advancedSearch.addSimpleFilter('projectid', this.projectid);

	}

	ngOnInit() {
		this.loadtools();
	}

	loadtools(): void {
		this.loading = true;
		this.rows = [];


		if (this.projectid) {
			this.advancedSearch.addSimpleFilter('projecttool.projectid', this.projectid);
		}

		if (this.companyid) {
			this.advancedSearch.addSimpleFilter('tool.companyid', this.companyid);
		}

		const datarequest = this.toolService.searchEntities(ProjectTool, 'projecttool', this.advancedSearch, this.advancedSearch.page);
		const countrequest = this.toolService.countEntities(ProjectTool, 'projecttool', this.advancedSearch);

		forkJoin([datarequest, countrequest]).subscribe(results => {
			this.advancedSearch.page.setTotal(results[1].ct);
			this.rows = results[0];
			this.loading = false;
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
			this.loading = false;
		});
	}

	onPageChange(pageInfo: any) {
		this.advancedSearch.page.setPageNumber(pageInfo.offset);
		this.loadtools();
	}

	onSortChange(sortInfo: any) {
		const sort = sortInfo.sorts[0];
		this.advancedSearch.setSortField(sort.prop);
		this.advancedSearch.setSortDirection(sort.dir);
		this.loadtools();
	}

	delete(tool: ProjectTool): void {
		this.dialogService.openConfirmModal({
			message: this.translateService.instant('labels.warning-tool-remove'),
			hasIcon: true,
			type: 'warning'
		}).then(result => {
			if (result) {
				this.toolService.deleteEntity(ProjectTool, 'projecttool', tool).subscribe(() => {
					this.translateService.get(['labels.tool-removed', 'labels.tools']).subscribe(messages => {
						this.messageService.sendSuccess(messages['labels.tool-removed'], messages['labels.tools']);
						this.loadtools();
					});
				});
			}
		});

	}

	add(): void {

		const modal = this.modalService.open(ProjectToolAddComponent, {
			centered: true,
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});
		modal.componentInstance.projectid = this.projectid;
		if (this.companyid) {
			modal.componentInstance.singlecompany = true;
			modal.componentInstance.companyid = this.companyid;
		}
		modal.componentInstance.loadAssociabletools();
		modal.componentInstance.loadAssociatetools();


		modal.result.then(() => {
			this.loadtools();
		}).catch(() => {
			this.loadtools();
		});

	}



}
